import React, { useState, useEffect, useRef } from "react";
import { StyledTextareaSection } from "./index.styled";
import editIcon from "../../../assets/icons/edit.webp";
import { Check, X } from "lucide-react";

interface TextareaSectionProps {
  title: string;
  icon: string;
  placeholder: string;
  value: string;
  iconSize?: number;
  onChange: (value: string) => void;
}

const TextareaSection: React.FC<TextareaSectionProps> = ({
  title,
  icon,
  placeholder,
  value,
  onChange,
  iconSize = 15,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const [tempValue, setTempValue] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleEditClick = () => {
    setTempValue(value);
    setIsEditable(true);
  };

  const handleCancel = () => {
    setIsEditable(false);
    setTempValue("");
  };

  const handleSave = () => {
    onChange(tempValue);
    setIsEditable(false);
    setTempValue("");
  };

  const hasChanges = () => {
    return tempValue !== value;
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && e.ctrlKey) {
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  useEffect(() => {
    if (isEditable && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [isEditable]);

  return (
    <StyledTextareaSection $isBigIcon={iconSize === 18}>
      <div className="header">
        <img
          src={icon}
          alt={`${title} icon`}
          style={{ width: iconSize, height: iconSize }}
        />
        <h3 className="title">{title}</h3>
      </div>
      <div className="textarea-container">
        {isEditable ? (
          <>
            <textarea
              ref={textareaRef}
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              placeholder={placeholder}
              className="textarea"
              onKeyDown={handleKeyPress}
            />
            <div className="button-container">
              {hasChanges() && (
                <button
                  className="save-button"
                  onClick={handleSave}
                  title="שמור"
                >
                  <Check size={16} />
                </button>
              )}
              <button
                className="cancel-button"
                onClick={handleCancel}
                title="בטל"
              >
                <X size={16} />
              </button>
            </div>
          </>
        ) : (
          <>
            <textarea
              value={value}
              onChange={(e) => onChange(e.target.value)}
              placeholder={placeholder}
              className="textarea read-only"
              readOnly
            />
            <button className="edit-button" onClick={handleEditClick}>
              <img src={editIcon} alt="edit" />
            </button>
          </>
        )}
      </div>
    </StyledTextareaSection>
  );
};

export default TextareaSection;
